module.exports = __webpack_public_path__ + "static/media/square_checkmark_active_bb.9a47c4ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/square_checkmark_active_bb.svg
// module id = 17
// module chunks = 0